<div mat-dialog-title fxLayoutAlign="space-between center">
  <h2>Secure Intake Code</h2>
</div>

<mat-dialog-content fxLayout="column" fxLayoutGap="10px">
  <div
    fxLayout="row"
    fxLayoutAlign="space-between center"
    fxLayoutGap="10px"
  >
    <ol fxFlex>
      <li>
        Have the patient goto:<br />
        <div>
          <strong>https://{{ clinicService.clinic.slug }}.patientpal.com/code</strong>
        </div>
        <ng-container *ngIf="data.link">
          <div>or</div>
          <div>
            <strong>{{ data.link }}</strong>
          </div>
        </ng-container>
      </li>
      <li class="mt-6">
        <div>Enter this code:</div>

        <div class="text-xxl">
          <code style="letter-spacing: 1rem">{{ data.code }}</code>
        </div>

        <div class="text-muted" *ngIf="data.code.includes('0')">
          Code contains a zero.
        </div>

        <div class="text-muted" *ngIf="data.code.includes('O')">
          Code contains the letter O, as in Orange.
        </div>
      </li>
    </ol>

    <img [src]="qrImage" style="max-width: 50%; max-height: 167px" />
  </div>
  <span class="text-muted"
    >This code will automatically expire in 60 minutes.</span
  >
</mat-dialog-content>

<mat-dialog-actions fxLayout="row" fxLayoutAlign="end center">
  <button mat-flat-button type="button" mat-dialog-close>OK</button>
</mat-dialog-actions>
